"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseTypeRegistry = exports.getAnticipatedResponseTypes = exports.EXIT_TYPES = void 0;
const Messages = __importStar(require("@keepkey/device-protocol/lib/messages_pb"));
const { default: { MessageType }, } = Messages; // Conflict between typedef and actual js export
exports.EXIT_TYPES = [
    String(MessageType.MESSAGETYPE_SUCCESS),
    String(MessageType.MESSAGETYPE_CANCEL),
    String(MessageType.MESSAGETYPE_FAILURE),
];
function getAnticipatedResponseTypes(msgTypeEnum) {
    return exports.responseTypeRegistry[msgTypeEnum] || exports.EXIT_TYPES;
}
exports.getAnticipatedResponseTypes = getAnticipatedResponseTypes;
exports.responseTypeRegistry = {
    [MessageType.MESSAGETYPE_INITIALIZE]: [String(MessageType.MESSAGETYPE_FEATURES), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_GETFEATURES]: [String(MessageType.MESSAGETYPE_FEATURES), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_GETCOINTABLE]: [String(MessageType.MESSAGETYPE_COINTABLE), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_CLEARSESSION]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_APPLYSETTINGS]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_CHANGEPIN]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_PING]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_BUTTONREQUEST]: [String(MessageType.MESSAGETYPE_BUTTONACK), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_PINMATRIXREQUEST]: [String(MessageType.MESSAGETYPE_PINMATRIXACK), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_PASSPHRASEREQUEST]: [String(MessageType.MESSAGETYPE_PASSPHRASEACK), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_GETENTROPY]: [String(MessageType.MESSAGETYPE_ENTROPY), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_GETPUBLICKEY]: [String(MessageType.MESSAGETYPE_PUBLICKEY), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_GETADDRESS]: [String(MessageType.MESSAGETYPE_ADDRESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_ETHEREUMGETADDRESS]: [String(MessageType.MESSAGETYPE_ETHEREUMADDRESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_WIPEDEVICE]: [String(MessageType.MESSAGETYPE_BUTTONREQUEST)],
    [MessageType.MESSAGETYPE_LOADDEVICE]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_RESETDEVICE]: [String(MessageType.MESSAGETYPE_ENTROPYREQUEST), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_ENTROPYREQUEST]: [String(MessageType.MESSAGETYPE_ENTROPYACK), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_ENTROPYACK]: [String(MessageType.MESSAGETYPE_BUTTONREQUEST), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_RECOVERYDEVICE]: [String(MessageType.MESSAGETYPE_WORDREQUEST), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_WORDACK]: [
        String(MessageType.MESSAGETYPE_WORDREQUEST),
        String(MessageType.MESSAGETYPE_SUCCESS),
        ...exports.EXIT_TYPES,
    ],
    [MessageType.MESSAGETYPE_CHARACTERACK]: [String(MessageType.MESSAGETYPE_CHARACTEREQUEST), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_SIGNMESSAGE]: [String(MessageType.MESSAGETYPE_MESSAGESIGNATURE), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_VERIFYMESSAGE]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_ENCRYPTMESSAGE]: [String(MessageType.MESSAGETYPE_ENCRYPTEDMESSAGE), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_DECRYPTMESSAGE]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_CIPHERKEYVALUE]: [String(MessageType.MESSAGETYPE_CIPHEREDKEYVALUE), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_ESTIMATETXSIZE]: [String(MessageType.MESSAGETYPE_TXSIZE), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_SIGNTX]: [String(MessageType.MESSAGETYPE_TXREQUEST), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_TXACK]: [String(MessageType.MESSAGETYPE_TXREQUEST), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_RAWTXACK]: [String(MessageType.MESSAGETYPE_TXREQUEST), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_ETHEREUMSIGNTX]: [String(MessageType.MESSAGETYPE_ETHEREUMTXREQUEST), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_ETHEREUMTXREQUEST]: [String(MessageType.MESSAGETYPE_ETHEREUMTXACK), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_ETHEREUMTXACK]: [String(MessageType.MESSAGETYPE_ETHEREUMTXREQUEST)],
    [MessageType.MESSAGETYPE_ETHEREUMSIGNMESSAGE]: [
        String(MessageType.MESSAGETYPE_ETHEREUMMESSAGESIGNATURE),
        ...exports.EXIT_TYPES,
    ],
    [MessageType.MESSAGETYPE_ETHEREUMVERIFYMESSAGE]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_ETHEREUMMESSAGESIGNATURE]: [String(MessageType.MESSAGETYPE_FEATURES), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_SIGNIDENTITY]: [String(MessageType.MESSAGETYPE_SIGNEDIDENTIY), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_APPLYPOLICIES]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_FLASHHASH]: [String(MessageType.MESSAGETYPE_FLASHHASHRESPONSE), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_FLASHWRITE]: [String(MessageType.MESSAGETYPE_FLASHHASHRESPONSE), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_DEBUGLINKFLASHDUMP]: [
        String(MessageType.MESSAGETYPE_DEBUGLINKFLASHDUMPRESPONSE),
        ...exports.EXIT_TYPES,
    ],
    [MessageType.MESSAGETYPE_FIRMWAREERASE]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_FIRMWAREUPLOAD]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_DEBUGLINKDECISION]: [String(MessageType.MESSAGETYPE_SUCCESS), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_DEBUGLINKGETSTATE]: [String(MessageType.MESSAGETYPE_DEBUGLINKSTATE), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_EOSGETPUBLICKEY]: [String(MessageType.MESSAGETYPE_EOSPUBLICKEY), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_EOSSIGNTX]: [String(MessageType.MESSAGETYPE_EOSTXACTIONREQUEST), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_EOSTXACTIONREQUEST]: [String(MessageType.MESSAGETYPE_EOSTXACTIONACK), ...exports.EXIT_TYPES],
    [MessageType.MESSAGETYPE_EOSTXACTIONACK]: [
        String(MessageType.MESSAGETYPE_EOSTXACTIONREQUEST),
        String(MessageType.MESSAGETYPE_EOSSIGNEDTX),
        ...exports.EXIT_TYPES,
    ],
};
//# sourceMappingURL=responseTypeRegistry.js.map